import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'

import type { RoomType } from '../constants/room-types'

type Params = {
  id?: string[]
  page?: number
  pageSize?: number
  type?: RoomType[]
}

const responseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    can_be_deleted: z.boolean()
  })
)

export const useRoomsIds = (params: Params) =>
  useQuery({
    queryKey: ['panelRoomsListIds', params],
    queryFn: async () => {
      const response = await httpService.panel.panelRoomsList({
        id: params.id,
        page: 1,
        page_size: 'max',
        room_type: params.type,
        fetchKeys: {
          id: true,
          name: true,
          can_be_deleted: true
        }
      })
      const parsed = responseSchema.parse(response.results)

      return parsed.map(room => ({
        id: room.id,
        name: room.name,
        canBeDeleted: room.can_be_deleted
      }))
    }
  })
